import { ISelect } from '../../../../shared/types/shared';

export const ADDRESS_LETTER_OPTIONS: ISelect[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    .split('')
    .map((letter) => ({ id: letter, name: letter }));
